import { useEffect, useState } from 'react';

/**
 * Debounce hook to delay the value change for a given amount of time (500ms by default)
 * @param value value to debounce (can be any type)
 * @param delay delay in ms
 */
function useDebounce<T>(value: T, delay?: number): T {
  /**
   * State and setters for debounced value
   */
  const [debouncedValue, setDebouncedValue] = useState<T>(value);

  /**
   * Effect that executes the debouncing
   */
  useEffect(() => {
    const timer = setTimeout(() => setDebouncedValue(value), delay || 500);

    return () => {
      clearTimeout(timer);
    };
  }, [value, delay]);

  return debouncedValue;
}

export default useDebounce;
